import React from 'react';
import Button from '../modules/Button'
import {TrackingLink} from "../modules/TrackingLink"

import Deploy from "../Deploy"
import AboutLink from "../AboutLink"


function CollectionDisplay( { collection, widget, children } ) {


  return (
    <header className={`collection-display ${collection.Image}`}>
      <div className='collection-display-gradient'></div>

      <section className="image-header">
        {!collection.NoHeader && (
          <div className="header-meta">Does That Degree Pay?</div>
        )}
        <h1>{collection.Title}</h1>

        <div className="subheader">{collection.Summary}</div>

        <Deploy.Widget>
          <TrackingLink href="https://inquirer.com/business/inq/most-valuable-college-degrees-20200331.html" className="button"  target="_parent" rel="noopener noreferrer" event="explore_database">
            Explore The Full Database
          </TrackingLink>
        </Deploy.Widget>

        <Deploy.Tool>
          <TrackingLink href={ collection.Link } className="button"  target="_parent" rel="noopener noreferrer" event="read_inquirer_story">
            {collection.LaunchCTA}
          </TrackingLink>
        </Deploy.Tool>

        <br/>

        <AboutLink/>

      </section>

      { children }


    </header>
  );
}

export default CollectionDisplay;
